(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bh3d-full-range-listings"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bh3d-full-listings')) {
  customElements.define('bh3d-full-listings', class extends HTMLElement {
    connectedCallback() {
      this.onView = () => {
        const view = new URL(location.href).searchParams.get('range_view');
        this.querySelectorAll('.pagination a[href]').forEach(link => {
          const url = new URL(link.getAttribute('href'), location.href);
          if (['armies', 'individual'].includes(view)) url.searchParams.set('range_view', view);
          else url.searchParams.delete('range_view');
          link.setAttribute('href', url.pathname + url.search + url.hash);
        });
      };
      window.addEventListener('bh3d:range-view', this.onView);
      window.addEventListener('popstate', this.onView);
      this.onView();
    }
    disconnectedCallback() {
      window.removeEventListener('bh3d:range-view', this.onView);
      window.removeEventListener('popstate', this.onView);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bh3d-home-search-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bh3d-home-hero')) {
  customElements.define('bh3d-home-hero', class extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-carousel')) return;
      this.frame = requestAnimationFrame(() => this.initialise());
    }
    initialise() {
      this.abort?.abort();
      this.abort = new AbortController();
      const listen = (target, event, handler) => target.addEventListener(event, handler, {signal: this.abort.signal});
      this.current = 0;
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reducedMotion.matches;
      this.hovered = false;
      this.focused = false;
      this.pauseButton = this.querySelector('[data-hero-pause]');
      this.querySelector('.bh3d-hero-carousel__controls').hidden = false;
      listen(this.querySelector('[data-hero-prev]'), 'click', () => this.show(this.current - 1, true));
      listen(this.querySelector('[data-hero-next]'), 'click', () => this.show(this.current + 1, true));
      this.querySelectorAll('[data-hero-dot]').forEach(button => listen(button, 'click', () => this.show(Number(button.dataset.heroDot), true)));
      listen(this.pauseButton, 'click', () => { this.paused = !this.paused; this.updatePause(); this.schedule(); });
      listen(this, 'pointerenter', event => { if (event.pointerType !== 'mouse') return; this.hovered = true; this.schedule(); });
      listen(this, 'pointerleave', () => { this.hovered = false; this.schedule(); });
      listen(this, 'focusin', () => { this.focused = true; this.schedule(); });
      listen(this, 'focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); });
      listen(document, 'visibilitychange', () => this.schedule());
      listen(this.reducedMotion, 'change', () => { if (this.reducedMotion.matches) {this.paused = true; this.updatePause(); this.schedule();} });
      this.updatePause();
      this.show(0);
    }
    updatePause() {
      const label = this.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
      this.pauseButton.textContent = label;
      this.pauseButton.setAttribute('aria-label', label);
    }
    show(index, manual = false) {
      this.current = (index + 2) % 2;
      this.querySelectorAll('[data-hero-slide]').forEach(slide => {
        const inactive = Number(slide.dataset.heroSlide) !== this.current;
        slide.inert = inactive;
        slide.setAttribute('aria-hidden', String(inactive));
      });
      this.querySelectorAll('[data-hero-dot]').forEach(button => {
        if (Number(button.dataset.heroDot) === this.current) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      if (manual) this.querySelector('[data-hero-status]').textContent = (this.current + 1) + ' / 2';
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || this.hovered || this.focused || document.hidden || !this.isConnected) return;
      this.timer = setTimeout(() => this.show(this.current + 1), Number(this.dataset.interval) || 8000);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      clearTimeout(this.timer);
      this.abort?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bh3d-range-intro"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bh3d-range-view')) {
  customElements.define('bh3d-range-view', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.controls = this.querySelector('.bh3d-range-view');
      this.buttons = Array.from(this.querySelectorAll('[data-range-view]'));
      this.groups = Array.from(this.querySelectorAll('[data-range-group]'));
      this.onHistory = () => this.show(new URL(location.href).searchParams.get('range_view') || 'all', false);
      this.onClick = (event) => {
        const button = event.target.closest('[data-range-view]');
        if (button && this.buttons.includes(button)) this.show(button.dataset.rangeView, true);
      };
      this.controls.addEventListener('click', this.onClick);
      window.addEventListener('popstate', this.onHistory);
      this.onHistory();
      this.controls.hidden = false;
    }
    disconnectedCallback() {
      window.removeEventListener('popstate', this.onHistory);
      this.controls?.removeEventListener('click', this.onClick);
      this.ready = false;
    }
    show(value, updateHistory) {
      const selected = ['armies', 'individual'].includes(value) ? value : 'all';
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.rangeView === selected)));
      this.groups.forEach(group => { group.hidden = selected !== 'all' && group.dataset.rangeGroup !== selected; });
      this.querySelector('[role="status"]').textContent = selected === 'all' ? 'Showing army and individual-set collections.' : selected === 'armies' ? 'Showing army collections.' : 'Showing individual-set collections.';
      if (updateHistory) {
        const url = new URL(location.href);
        url.searchParams.delete('range_page');
        if (selected === 'all') url.searchParams.delete('range_view');
        else url.searchParams.set('range_view', selected);
        if (url.href !== location.href) history.pushState(history.state, '', url);
      }
      window.dispatchEvent(new CustomEvent('bh3d:range-view'));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bh3d-splash-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bh3d-splash')) {
  customElements.define('bh3d-splash', class extends HTMLElement {
    connectedCallback() {
      if(this.ready)return;this.ready=true;
      this.slides=[...this.querySelectorAll('[data-slide]')];this.index=0;
      this.controls=this.querySelector('[data-controls]');if(!this.controls)return;
      this.controls.hidden=false;this.motion=matchMedia('(prefers-reduced-motion: reduce)');
      this.playing=this.dataset.autoplay==='true'&&!this.motion.matches;
      this.querySelectorAll('[data-index]').forEach(b=>b.addEventListener('click',()=>{this.stop();this.show(Number(b.dataset.index));}));
      this.querySelector('[data-next]').addEventListener('click',()=>{this.stop();this.show(this.index+1);});
      this.querySelector('[data-prev]').addEventListener('click',()=>{this.stop();this.show(this.index-1);});
      this.querySelector('[data-play]').addEventListener('click',()=>{this.playing=!this.playing;this.schedule();});
      this.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.stop();this.show(this.index+(e.key==='ArrowRight'?1:-1));}});
      this.addEventListener('mouseenter',()=>{this.hovered=true;this.schedule();});this.addEventListener('mouseleave',()=>{this.hovered=false;this.schedule();});
      this.addEventListener('focusin',()=>{this.focused=true;this.schedule();});this.addEventListener('focusout',()=>{queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.schedule();});});
      this.visibility=()=>this.schedule();document.addEventListener('visibilitychange',this.visibility);
      this.motionChange=()=>{if(this.motion.matches)this.stop();};this.motion.addEventListener('change',this.motionChange);
      this.editor=e=>{const index=this.slides.findIndex(s=>s.contains(e.target));if(index>=0){this.stop();this.show(index);}};document.addEventListener('shopify:block:select',this.editor);
      this.schedule();
    }
    show(index){this.index=(index+this.slides.length)%this.slides.length;this.slides.forEach((s,i)=>s.hidden=i!==this.index);this.querySelectorAll('[data-index]').forEach((b,i)=>b.setAttribute('aria-pressed',String(i===this.index)));this.schedule();}
    stop(){this.playing=false;this.schedule();}
    schedule(){clearTimeout(this.timer);const b=this.querySelector('[data-play]');if(!b)return;b.textContent=this.playing?'Pause':'Play';b.setAttribute('aria-label',this.playing?'Pause slideshow':'Play slideshow');this.querySelector('.bh3d-splash__slides').setAttribute('aria-live',this.playing?'off':'polite');if(this.playing&&!this.hovered&&!this.focused&&!document.hidden)this.timer=setTimeout(()=>this.show(this.index+1),Number(this.dataset.interval)||8000);}
    disconnectedCallback(){clearTimeout(this.timer);document.removeEventListener('visibilitychange',this.visibility);document.removeEventListener('shopify:block:select',this.editor);this.motion?.removeEventListener('change',this.motionChange);}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
